<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Export Raw Data
      </div>
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div
        v-if="show"
        class="ac-error-container"
      >
        <div class="error-text">
          Date range has to be less than 10 days.
          {{ "\n" }}
          Please select different range and try again.
        </div>
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Range
        </div>
        <div class="radio-timezone">
          <label class="radio"><input
            v-model="timezoneSelected"
            type="radio"
            :value="hubTimezone"
          > Hub Time</label>
          <label class="radio"><input
            v-model="timezoneSelected"
            type="radio"
            value=":00.000Z"
          > UTC</label>
        </div>
        <div class="range-container">
          <div class="date-container">
            <div class="date">
              <input
                v-model="startDate"
                type="datetime-local"
                name="startDate"
              >
            </div>
          </div>
          <span class="divider">--</span>
          <div class="date-container">
            <div class="date">
              <input
                v-model="endDate"
                type="datetime-local"
                name="endDate"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Device
        </div>
        <SACDropdown
          placeholder="Select UID"
          :options="getHVAC"
          field="uid"
          :value="selectedExportUid"
          :change="(field, value) => setExportUid(field, value)"
        />
      </div>
      <ProcessOverlay
        :show="generatingCSV"
        text="Generating CSV"
        overlayClass="ac-overlay"
      />
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        :disabled="disableBtn()"
        @click="exportCSVData()"
      >
        Export
      </button>
    </div>
  </div>
</template>

<script>
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import { mapState } from 'vuex';
import CustomerDetailMixin from '../../mixins/customerDetailMixin';
import SACDropdown from '../sac/SACDropdown.vue';

export default {
  name: 'ExportRawForm',
  components: {
    SACDropdown,
    ProcessOverlay,
  },
  mixins: [CustomerDetailMixin],
  data() {
    const tz = this.$store.state.customerDetail.hubs[0].tzOffset;
    const tzSplit = tz.toString().split('');
    if (tzSplit[0] !== '-') tzSplit.unshift('+');
    const today = new Date();
    today.setSeconds(0);
    today.setMilliseconds(0);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    return {
      today,
      endDate: today.toISOString().substring(0, 16),
      startDate: yesterday.toISOString().substring(0, 16),
      timezoneSelected: ':00.000Z',
      hubTimezone: `:00.000${tzSplit[0] + (tzSplit[2] ? tzSplit[1] + tzSplit[2] : `0${tzSplit[1]}`)
      }`,
    };
  },
  watch: {
    timezoneSelected(t) {
      this.$store.dispatch('setExportRange', { start: this.startDate + t });
      this.$store.dispatch('setExportRange', { end: this.endDate + t });
    },
    endDate(end) {
      this.$store.dispatch('setExportRange', { end: end + this.timezoneSelected });
    },
    startDate(start) {
      this.$store.dispatch('setExportRange', { start: start + this.timezoneSelected });
    },
  },
  mounted() {
    const today = new Date();
    today.setSeconds(0);
    today.setMilliseconds(0);
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    this.$store.dispatch('setExportRange', { end: today.toISOString() });
    this.$store.dispatch('setExportRange', { start: yesterday.toISOString() });
  },
  methods: {
    disableBtn() {
      return !(this.selectedExportUid && this.exportCSV.range.start && this.exportCSV.range.end);
    },
    setExportUid(field, value) {
      this.$store.dispatch('setExportRange', {
        uid: value,
      });
    },
    async exportCSVData() {
      await this.$store.dispatch('changeCustomerDetailValue', {
        field: 'showWrongDateRangePopup',
        value: false,
      });
      const result = await this.$store.dispatch('exportRawDataCSV');
      if (result.data) {
        this.toggleActionModal(false);
        const { data, fileName } = result;
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${fileName}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      if (!this.show) {
        this.$store.dispatch('resetExportCSVRange');
      }
    },
  },
  computed: {
    ...mapState({
      show: (state) => state.customerDetail.showWrongDateRangePopup,
    }),
    getHVAC() {
      const hvacOptions = this.hvac.map((p) => ({
        value: `${p.uid}`,
        label: `${p.uid} ${p.zone ? `- ${p.zone}` : ''}`,
      }));
      return hvacOptions;
    },
    selectedDate: {
      get() {
        const { start, end } = this.$store.getters.getExportCSVRange.range;
        return {
          start,
          end,
        };
      },
      set(dates) {
        const { start, end } = dates;
        if (start) {
          this.$store.dispatch('setExportRange', {
            range: {
              start,
              end,
            },
          });
          this.$store.dispatch('resetSelectedPoint');
        }
      },
    },
  },
};
</script>
